import api from './api'

export default class ApiUmkd {

    // Получение направлений подготовки
    static async getDirectionTraining(): Promise<any> {
        try {
            return await api.get('/umkd/getDirectionTraining')
        } catch (error) {
            return error
        }
    }

    // Получение специализаций
    static async getSpecialization(directionTrainingID: number): Promise<any> {
        try {
            return await api.get(`/umkd/getSpecialization?directionTrainingID=${directionTrainingID}`)
        } catch (error) {
            return error
        }
    }

    // Получение дисциплин
    static async getSubjects(specializationID: number): Promise<any> {
        try {
            return await api.get(`/umkd/getSubjects?specializationID=${specializationID}`)
        } catch (error) {
            return error
        }
    }

    // Получение файлов
    static async getFiles(subjectID: number): Promise<any> {
        try {
            return await api.get(`/umkd/getFiles?subjectID=${subjectID}`)
        } catch (error) {
            return error
        }
    }

    // Удаление файлов
    static async deleteFile(fileID: number): Promise<any> {
        try {
            return await api.delete(`/umkd/deleteFile?fileID=${fileID}`)
        } catch (error) {
            return error
        }
    }

    // Перемещение файла в другой раздел
    static async movedFile(fileID: number, fileMoveType: string): Promise<any> {
        try {
            return await api.post(`/umkd/movedFile`, {fileID, fileMoveType})
        } catch (error) {
            return error
        }
    }

    // Загрузка файлов УМКД
    static async uploadUmkd(file: any, subjectID: number, fileType: string, fileName: string): Promise<any> {
        const formData = new FormData()
        formData.append("umkd", file)

        try {
            // console.log(formData)
            return await api.post(`/umkd/uploadUmkd?subjectID=${subjectID}&fileType=${fileType}&fileName=${fileName}`, formData, { headers: { "Content-Type": `multipart/form-data` } })
        } catch (error) {
            return error
        }
    }
    
}